import Reveal from "@/components/Reveal";

export default function PageHero({ eyebrow, title, lede, testid = "page-hero" }) {
  return (
    <section className="relative overflow-hidden bg-navy-950 pt-40 pb-20 lg:pt-48 lg:pb-24" data-testid={testid}>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.12]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(212,175,55,0.35) 1px, transparent 1px), linear-gradient(90deg, rgba(212,175,55,0.35) 1px, transparent 1px)",
          backgroundSize: "72px 72px",
        }}
      />
      <div aria-hidden className="pointer-events-none absolute -top-32 right-0 h-96 w-96 rounded-full bg-gold/10 blur-3xl" />
      <div className="container-rcs relative">
        <Reveal>
          {eyebrow && <p className="eyebrow-light">{eyebrow}</p>}
          <h1 className="mt-4 max-w-4xl font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-ivory">
            {title}
          </h1>
          {lede && <p className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-slate-300">{lede}</p>}
        </Reveal>
      </div>
    </section>
  );
}
